<template>
  <div class="transition-container"></div>
</template>
<script>

export default {
  components: {},
  data() {
    return {}
  },
  created() {

  },
  mounted() {}
}
</script>

<style lang="scss">
</style>
